module.exports = __webpack_public_path__ + "static/media/careme.9ae97fae.png";